import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { HomeUseFailure, HomeUseRequest, HomeUseSuccess } from './actions';
import { HomeUseService } from './service';

@Injectable()
export class HomeUseEffects {
  private readonly actions$ = inject(Actions);
  private readonly homeUseService = inject(HomeUseService);

  homeUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HomeUseRequest),
      switchMap(({ parameters }) =>
        this.homeUseService.homeUse(parameters).pipe(
          map(data => HomeUseSuccess({ data })),
          catchError(error => of(HomeUseFailure({ error })))
        )
      )
    )
  );

}
